import type { KoliBriTableHeaders, TabButtonProps } from '@public-ui/components';
import { KolNav, KolTableStateful, KolTabs } from '@public-ui/react-v19';
import * as React from 'react';
import { SampleDescription } from '../../components/SampleDescription';
import { LINKS } from '../../components/nav/links';
import DATA from './databasedata.json';

import './layout.scss';

const TABS: TabButtonProps[] = [
	{
		_icons: 'fa-solid fa-chart-pie',
		_label: 'Erster Tab',
	},
	{
		_icons: 'fa-solid fa-calendar',
		_label: 'Zweiter Tab',
		_disabled: true,
	},
	{
		_icons: 'fa-solid fa-briefcase',
		_label: 'Deaktivierter Tab',
		_disabled: true,
	},
	{
		_icons: 'fa-solid fa-address-card',
		_label: 'Letzter Tab',
		_disabled: true,
	},
];

const HEADERS: KoliBriTableHeaders = {
	horizontal: [
		[
			{ key: 'name', label: 'Name', textAlign: 'left' },
			{ key: 'species', label: 'Species', textAlign: 'left' },
			{ key: 'habitat', label: 'Habitat', textAlign: 'left' },
			{ key: 'diet', label: 'Diet', textAlign: 'left' },
			{ key: 'lifespan', label: 'lifespan', textAlign: 'right' },
		],
	],
};

function TableHorizontalScrollbarAdvanced() {
	return (
		<>
			<SampleDescription>
				<p>
					This advanced scenario demonstrates a complex layout with KolTable featuring horizontal scrollbar within a tab-based navigation system. The table
					automatically calculates its minimum width based on column definitions and provides smooth horizontal scrolling when content exceeds the container
					width. This example showcases real-world usage in a dashboard-like interface with sidebar navigation and tabbed content areas.
				</p>
			</SampleDescription>
			<div className="mainlayout">
				<aside className="nav-area">
					<KolNav _label="Main navigation" _links={LINKS} _hasCompactButton _hasIconsWhenExpanded />
				</aside>
				<div className="content">
					<KolTabs _tabs={TABS} _align="top" _label="Demo Tabs">
						<div style={{ overflow: 'hidden' }}>
							<KolTableStateful
								_label="Table for demonstration purposes with horizontal scrollbar"
								_headers={HEADERS}
								_data={DATA}
								_pagination={{ _page: 1 }}
								className="block"
							/>
						</div>
						<div></div>
						<div></div>
						<div></div>
					</KolTabs>
				</div>
			</div>
		</>
	);
}

export default TableHorizontalScrollbarAdvanced;
